// Using IframeLessons to embed Content Layer course
import IframeLessons from './IframeLessons';

export default IframeLessons;
